import AsyncLoader from 'component/AsyncLoader';

export const ApplyInvoice =  AsyncLoader(() => import('./ApplyInvoice'));
export const InvoiceInquiry =  AsyncLoader(() => import('./InvoiceInquiry'));
export const BillAddress =  AsyncLoader(() => import('./BillAddress'));